<template>
  <div class="f360-aviso-bwa">
    <div class="content-left">
      <img
        :src="logobwa"
        alt="logo bwa"
        style="width: 30px; margin-right: 10px"
      />
      <p>
        <b>Webinar gratuito:</b> Prepare-se para a Reforma Tributária – 12/02 às
        9h30!
      </p>
    </div>
    <div class="content-right">
      <el-button class="banner-button" @click="handleLink">
        <span class="banner-button__label">
          Inscreva-se
          <!-- <span class="display-btn-text hidden-sm-and-down"></span> -->
          <!-- <MaterialIcon class="banner-button__icon" icon="arrow_outward" /> -->
        </span>
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElButton } from "element-plus/es/components/button/index";
//import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import logobwa from "@/ui/assets/shared/parceiros/bwa-loog-sem-fundo.png";
//import logobwa from "@/ui/assets/shared/parceiros/logo-bwa.png";

const handleLink = () => {
  window.open("https://go.f360.com.br/40Zf8DA", "_blank");
};
</script>

<style lang="scss" scoped>
@use "@/ui/styles/theme/f360-theme" as *;
@use "@/ui/styles/variables" as *;

.f360-aviso-bwa {
  font-family: $fontFamily;
  width: auto;
  height: 1.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem;
  background-color: #f9f9f9;
  color: #464646;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
  margin: 7px 0 0px 0;

  border-radius: 5px;
  border: 1px solid transparent;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(to right, #f9ce37, #ea575c) border-box;
  background-clip: padding-box, border-box;

  .content-left {
    display: flex;
    align-items: center;
  }

  .content-right {
    display: flex;
    align-items: center;

    p {
      margin-right: 10px;
    }

    .banner-button {
      //com cor
      height: 32px;
      width: fit-content;
      padding: 0 11px;
      border-radius: 5px;
      border: 1px solid transparent;
      background: linear-gradient(#f9ce37, #ea575c) padding-box;
      background-clip: padding-box, border-box;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
      transition: background-color 0.3s ease, color 0.3s ease;

      //botao preto
      // height: 32px;
      // width: fit-content;
      // padding: 0 11px;
      // border-radius: 5px;
      // border: 1px solid #E7E7E7;
      // background-color: #464646;
      // font-weight: 400;
      // color: #E7E7E7;
      // cursor: pointer;
      // background: linear-gradient(to right, #F9CE37, #EA575C) 1;

      &__label {
        display: flex;
        align-items: center;
        gap: 7px;

        font-family: $fontFamily;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;

        &--small {
          font-size: 10px;
          line-height: 10px;
        }
      }

      &__icon {
        font-size: 15px;
      }

      @media (min-width: 768px) and (max-width: 1200px) {
        .display-btn-text {
          display: none;
        }
      }
    }

    .banner-button:hover {
      background-color: #797979;
      color: #ffffff;
    }
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: auto;

    .content-left {
      display: flex;
      flex-direction: column;

      p {
        text-align: center;
      }
    }
  }
}
</style>
